export class ErrorMessage {
  public errorStatus: number = 404;
  public errorMessage: string = "Page Not Found";
  public errorMessageDetail: string = "The requested page cannot be found.";
  public errorRedirectUrl: string =
    "https://" + import.meta.env.VITE_BASE_URL + "/login";
  public errorRedirectLocation: string = "login";

  constructor() {}

  setErrorStatus(errorStatus: number) {
    this.errorStatus = errorStatus;
    this.updateInfo();
  }

  private updateInfo() {
    if (this.errorStatus == 404) {
      this.errorMessage = "Page Not Found";
      this.errorMessageDetail = "The requested page cannot be found.";
      this.errorRedirectUrl =
        "https://" + import.meta.env.VITE_BASE_URL + "/login";
      this.errorRedirectLocation = "login";
    } else if (this.errorStatus == 403) {
      this.errorMessage = "Forbidden";
      this.errorMessageDetail =
        "You do not have the permissions to access this page.";
      this.errorRedirectUrl =
        "https://" + import.meta.env.VITE_BASE_URL + "/login";
      this.errorRedirectLocation = "login";
    } else if (this.errorStatus == 401) {
      this.errorMessage = "Unauthorized";
      this.errorMessageDetail = "You are not logged in.";
      this.errorRedirectUrl =
        "https://" + import.meta.env.VITE_BASE_URL + "/login";
      this.errorRedirectLocation = "login";
    } else if (this.errorStatus >= 500) {
      this.errorMessage = "Server Error";
      this.errorMessageDetail = "Please contact your technician.";
      this.errorRedirectUrl = "";
      this.errorRedirectLocation = "";
    } else {
      this.errorStatus = 404;
      this.errorMessage = "Page Not Found";
      this.errorMessageDetail = "The requested page cannot be found.";
      this.errorRedirectUrl =
        "https://" + import.meta.env.VITE_BASE_URL + "/login";
      this.errorRedirectLocation = "login";
    }
  }
}
